(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_aqee-panier-upsell"] && !Shopify.designMode) return;
  try {
    /**
   * Upsell du panier latéral AqeeLab : ajout au panier et choix de variante.
   * La liste est calculée en Liquid ; le tiroir est re-rendu après l'ajout,
   * ce qui retire le produit ajouté de la liste.
   */
  (() => {
    if (customElements.get('aqee-panier-upsell')) return;

    const theme = () => (typeof Theme !== 'undefined' ? Theme : window.Theme) || {};

    class AqeePanierUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }

      onChange = (event) => {
        const select = event.target.closest('[data-ref="variant"]');
        if (!select) return;

        const card = select.closest('.aqee-pu__card');
        const option = select.selectedOptions[0];
        card.querySelector('[data-ref="add"]').dataset.variantId = select.value;
        const price = card.querySelector('[data-ref="price"]');
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      };

      onClick = (event) => {
        const button = event.target.closest('[data-ref="add"]');
        if (!button) return;
        event.preventDefault();
        this.add(button);
      };

      /**
       * Suivi de l'upsell : chaque ajout est noté dans l'attribut caché du panier
       * `_aqee_upsell` (handles séparés par des virgules, « :offert » pour le
       * shaker offert). Il suit le panier jusqu'à la commande, sans être montré au
       * client. Au niveau du panier et pas de la ligne : une propriété de ligne
       * séparerait le produit en deux lignes et casserait la remise par volume.
       * Noté avant l'ajout, pour que le tiroir re-rendu porte déjà la valeur.
       */
      async noter(button) {
        const entree = button.dataset.handle + (button.dataset.gift ? ':offert' : '');
        const log = [this.dataset.log, entree].filter(Boolean).join(',');
        try {
          await fetch(theme().routes?.cart_update_url || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _aqee_upsell: log } }),
          });
          this.dataset.log = log;
        } catch (error) {
          // Le suivi ne doit jamais empêcher l'ajout.
        }
      }

      async add(button) {
        const card = button.closest('.aqee-pu__card');
        const drawer = this.closest('cart-drawer');
        const item = { id: Number(button.dataset.variantId), quantity: 1 };
        if (button.dataset.gift) item.properties = { _aqee_gift: button.dataset.gift };

        card.classList.add('is-loading');

        try {
          await this.noter(button);
          const response = await fetch(theme().routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [item],
              sections: drawer?.dataset.sectionId || '',
              sections_url: window.location.pathname,
            }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload?.description || payload?.message || 'Ajout impossible');

          if (!drawer) {
            window.location.reload();
            return;
          }

          const count = document.querySelector('cart-icon')?.getCurrentItemCount?.();
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                resource: {},
                data: {
                  itemCount: count == null ? undefined : count + 1,
                  source: 'aqee-panier-upsell',
                  sections: payload.sections,
                },
              },
            }),
          );
        } catch (error) {
          card.classList.remove('is-loading');
          document.dispatchEvent(
            new CustomEvent('toast:open', { detail: { type: 'error', message: error.message } }),
          );
        }
      }
    }

    customElements.define('aqee-panier-upsell', AqeePanierUpsell);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aqee-abo-lots"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('aqee-abo-lots')) return;

    class AqeeAboLots extends HTMLElement {
      connectedCallback() {
        this.min = parseInt(this.dataset.minQuantity, 10) || 0;
        this.matchFrequency = this.dataset.matchFrequency === 'true';
        if (this.min < 2 && !this.matchFrequency) return;

        // setTimeout : laisser quantity-breaks.js finir de changer la case choisie
        this.schedule = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.update(), 0);
        };
        document.addEventListener('quantity-breaks:updated', this.schedule);
        document.addEventListener('variant:updated', this.schedule);
        document.addEventListener('click', this.onClick = (event) => {
          if (event.target.closest?.('quantity-break-item')) this.schedule();
        });

        // Changement de saveur : on note l'état avant que le thème remette l'abonnement à zéro
        // (phase de capture : avant le script du sélecteur de saveur), puis on le rétablit
        // au « subscription:updated » qui suit la remise à zéro, ou au bout de 3 s au plus tard.
        document.addEventListener('change', this.onPick = (event) => {
          if (event.target.closest?.('variant-picker')) this.snapshot();
        }, true);
        document.addEventListener('subscription:updated', this.onSubscription = () => {
          if (this.pending) setTimeout(() => this.restore(), 0);
        });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.update(), { once: true });
        } else {
          this.update();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('quantity-breaks:updated', this.schedule);
        document.removeEventListener('variant:updated', this.schedule);
        document.removeEventListener('click', this.onClick);
        document.removeEventListener('change', this.onPick, true);
        document.removeEventListener('subscription:updated', this.onSubscription);
        clearTimeout(this.timer);
        clearTimeout(this.pendingTimer);
      }

      update() {
        const form = document.querySelector('[data-ref="product-form"]');
        const subscription = form?.querySelector('[data-ref="subscription"]');
        if (!subscription || subscription.dataset.requiresSellingPlan === 'true') return;

        const items = [...form.querySelectorAll('quantity-break-item')];
        const selected = items.find((item) => item.classList.contains('quantity-break--selected'));
        const quantity = parseInt(selected?.dataset.quantity, 10) || 1;
        const hide = this.min >= 2 && quantity >= this.min;
        subscription.classList.toggle('aqee-abo-masque', hide);

        const subscribed = subscription.querySelector('[data-ref="subscription-option"]');
        const oneTime = subscription.querySelector('[data-ref="one-time-option"]');
        // Abonnement coché puis lot de 6 choisi : on repasse en achat unique
        if (hide && subscribed?.checked && oneTime && !oneTime.checked) oneTime.click();

        if (!hide && this.matchFrequency && quantity !== this.lastQuantity) {
          this.selectFrequency(subscription, Math.max(0, items.indexOf(selected)), !!subscribed?.checked);
        }
        this.lastQuantity = quantity;
      }

      get subscription() {
        return document.querySelector('[data-ref="product-form"] [data-ref="subscription"]');
      }

      frequencyIndex(subscription) {
        const inputs = [...subscription.querySelectorAll('[data-ref="frequency-input"]')];
        if (inputs.length) return Math.max(0, inputs.findIndex((input) => input.checked));
        return Math.max(0, subscription.querySelector('[data-ref="frequency-select"]')?.selectedIndex ?? 0);
      }

      snapshot() {
        const subscription = this.subscription;
        if (!subscription || subscription.dataset.requiresSellingPlan === 'true') return;
        this.pending = {
          subscribed: !!subscription.querySelector('[data-ref="subscription-option"]')?.checked,
          frequency: this.frequencyIndex(subscription),
        };
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(() => this.restore(), 3000);
      }

      restore() {
        const state = this.pending;
        const subscription = this.subscription;
        if (!state || !subscription) return;
        this.pending = null;
        clearTimeout(this.pendingTimer);

        const option = subscription.querySelector('[data-ref="subscription-option"]');
        const hidden = subscription.classList.contains('aqee-abo-masque');
        if (state.subscribed && !hidden && option && !option.checked) option.click();
        this.selectFrequency(subscription, state.frequency, !!option?.checked);
      }

      // En achat unique, un clic sur une fréquence ferait passer en abonnement : on la coche sans
      // événement, et le thème la reprend quand le client choisit l'abonnement.
      selectFrequency(subscription, index, subscribed) {
        const inputs = [...subscription.querySelectorAll('[data-ref="frequency-input"]')];
        if (inputs.length) {
          const target = inputs[Math.min(index, inputs.length - 1)];
          if (target.checked) return;
          if (subscribed) target.click();
          else target.checked = true;
          return;
        }
        const select = subscription.querySelector('[data-ref="frequency-select"]');
        if (!select?.options.length) return;
        const option = select.options[Math.min(index, select.options.length - 1)];
        if (select.value === option.value) return;
        select.value = option.value;
        if (subscribed) select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('aqee-abo-lots', AqeeAboLots);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aqee-cagnotte"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('aqee-cagnotte')) return;

    const POINTS = /(\d+)\s*points?/i;
    // Premier prix du bouton panier : « Ajouter 126,78 € 140,85 € » → 12678
    const PRICE = /(\d+(?:[\s\u202f]\d{3})*)[,.](\d{2})\s*€/;

    class AqeeCagnotte extends HTMLElement {
      connectedCallback() {
        this.cents = parseFloat(this.dataset.pointCents) || 0;
        this.template = this.dataset.text || '';
        if (!this.cents || !this.template.includes('[montant]')) return;

        this.observer = new MutationObserver(() => this.update());
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.watch(), { once: true });
        } else {
          this.watch();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      get button() {
        return document.querySelector('[data-ref="product-form"] [name="add"]');
      }

      watch() {
        const options = { childList: true, characterData: true, subtree: true };
        document.querySelectorAll('.loy-product-point-title').forEach((title) => this.observer.observe(title, options));
        if (this.button) this.observer.observe(this.button, options);
        this.update();
      }

      // Prix d'une unité, sans remise de lot : celui sur lequel Loyoly compte ses points
      unitCents() {
        const single = document.querySelector('quantity-break-item[data-quantity="1"]');
        return parseInt(single?.dataset.totalPrice, 10) || 0;
      }

      selectedCents() {
        const match = this.button?.innerText.match(PRICE);
        return match ? parseInt(match[1].replace(/[\s\u202f]/g, '') + match[2], 10) : 0;
      }

      update() {
        // 1. Loyoly vient d'écrire « Gagne N points » : on en déduit son coefficient
        document.querySelectorAll('.loy-product-point-title').forEach((title) => {
          const match = title.textContent.match(POINTS);
          if (!match) return;
          const unit = this.unitCents();
          const points = parseInt(match[1], 10);
          this.multiplier = unit > 0 ? points / Math.ceil(unit / 100) : this.multiplier || 1;
          this.fallbackPoints = points;
          title.dataset.aqCagnotte = 'true';
        });
        if (this.multiplier === undefined) return;

        // 2. Points de la commande choisie, puis euros
        const total = this.selectedCents();
        const points = total > 0 ? Math.ceil(Math.ceil(total / 100) * this.multiplier) : this.fallbackPoints;
        const euros = ((points * this.cents) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
        const text = this.template.replace('[montant]', euros);

        // N'écrire que si le texte change, sinon l'observateur se relancerait sans fin
        document.querySelectorAll('.loy-product-point-title[data-aq-cagnotte]').forEach((title) => {
          if (title.textContent !== text) title.textContent = text;
        });
      }
    }

    customElements.define('aqee-cagnotte', AqeeCagnotte);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aqee-delivery-eta"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('aqee-delivery-eta')) return;

    const TZ = 'Europe/Paris';
    const DAY = 86400000;

    /* Date "civile" = minuit UTC du jour voulu : l'arithmétique de jours
       ne dépend ainsi ni du fuseau du visiteur ni des changements d'heure. */
    const civil = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
    const addDays = (date, n) => new Date(date.getTime() + n * DAY);
    const key = (date) => date.toISOString().slice(0, 10);

    const parisParts = (instant) => {
      const parts = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
      }).formatToParts(instant).forEach((p) => { parts[p.type] = Number(p.value); });
      return parts;
    };

    /* Instant réel correspondant à une heure murale de Paris. */
    const parisInstant = (date, minutes) => {
      const wall = date.getTime() + minutes * 60000;
      let guess = wall;
      for (let i = 0; i < 2; i++) {
        const p = parisParts(new Date(guess));
        const shown = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
        guess += wall - shown;
      }
      return guess;
    };

    /* Dimanche de Pâques (algorithme de Meeus / Butcher). */
    const easter = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return civil(y, month, day);
    };

    const frenchHolidays = (y, withPentecost) => {
      const e = easter(y);
      const list = [
        civil(y, 1, 1), addDays(e, 1), civil(y, 5, 1), civil(y, 5, 8), addDays(e, 39),
        civil(y, 7, 14), civil(y, 8, 15), civil(y, 11, 1), civil(y, 11, 11), civil(y, 12, 25),
      ];
      if (withPentecost) list.push(addDays(e, 50));
      return list.map(key);
    };

    /* Fermetures : une date par ligne (2026-12-24) ou une période (2026-08-03 > 2026-08-21). */
    const parseClosures = (raw) => {
      const out = [];
      (raw || '').split(/\n|,/).forEach((line) => {
        const found = line.match(/\d{4}-\d{2}-\d{2}/g);
        if (!found) return;
        const [y1, m1, d1] = found[0].split('-').map(Number);
        let current = civil(y1, m1, d1);
        const [y2, m2, d2] = (found[1] || found[0]).split('-').map(Number);
        const end = civil(y2, m2, d2);
        for (let n = 0; current <= end && n < 366; n++) {
          out.push(key(current));
          current = addDays(current, 1);
        }
      });
      return out;
    };

    const fmt = (options) => new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', ...options });
    const fmtLong = fmt({ weekday: 'long', day: 'numeric', month: 'long' });
    const fmtShort = fmt({ weekday: 'short', day: 'numeric', month: 'short' });
    const fmtWeekday = fmt({ weekday: 'long' });

    const escapeHtml = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

    class AqeeDeliveryEta extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.cfg = {
          cutoff: Number(d.cutoff),
          prep: Number(d.prep),
          transitMin: Math.max(0, Number(d.transitMin)),
          transitMax: Math.max(Number(d.transitMin), Number(d.transitMax)),
          shipSaturday: d.shipSaturday === 'true',
          deliverSaturday: d.deliverSaturday === 'true',
          pentecost: d.pentecost === 'true',
          closures: new Set(parseClosures(d.closures)),
        };
        try {
          this.texts = JSON.parse(this.querySelector('[data-texts]').textContent);
        } catch (e) {
          this.texts = {};
        }
        this.holidayCache = {};
        this.render();
        this.timer = setInterval(() => this.render(), 30000);
        this.onVisible = () => { if (!document.hidden) this.render(); };
        document.addEventListener('visibilitychange', this.onVisible);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisible);
      }

      isHoliday(date) {
        const y = date.getUTCFullYear();
        if (!this.holidayCache[y]) this.holidayCache[y] = new Set(frenchHolidays(y, this.cfg.pentecost));
        return this.holidayCache[y].has(key(date));
      }

      isShipDay(date) {
        const wd = date.getUTCDay();
        if (wd === 0 || (wd === 6 && !this.cfg.shipSaturday)) return false;
        return !this.isHoliday(date) && !this.cfg.closures.has(key(date));
      }

      isDeliveryDay(date) {
        const wd = date.getUTCDay();
        if (wd === 0 || (wd === 6 && !this.cfg.deliverSaturday)) return false;
        return !this.isHoliday(date);
      }

      advance(date, count, test) {
        let current = date;
        let left = count;
        while (left > 0) {
          current = addDays(current, 1);
          if (test(current)) left--;
        }
        return current;
      }

      compute(nowMs) {
        const p = parisParts(new Date(nowMs));
        const today = civil(p.year, p.month, p.day);
        const nowMinutes = p.hour * 60 + p.minute;

        let orderDay = today;
        if (!this.isShipDay(today) || nowMinutes >= this.cfg.cutoff) {
          orderDay = this.advance(today, 1, (x) => this.isShipDay(x));
        }
        const shipDay = this.advance(orderDay, this.cfg.prep, (x) => this.isShipDay(x));
        const nextDelivery = (x) => this.isDeliveryDay(x);
        const deliveryMin = this.advance(shipDay, this.cfg.transitMin, nextDelivery);
        const deliveryMax = this.advance(shipDay, this.cfg.transitMax, nextDelivery);
        const deadline = parisInstant(orderDay, this.cfg.cutoff);

        return { today, orderDay, shipDay, deliveryMin, deliveryMax, deadline, left: deadline - nowMs };
      }

      relative(date, today) {
        const diff = Math.round((date - today) / DAY);
        if (diff === 0) return this.texts.today || "aujourd'hui";
        if (diff === 1) return this.texts.tomorrow || 'demain';
        return null;
      }

      render() {
        const now = Date.now();
        const r = this.compute(now);
        const t = this.texts;
        const set = (ref, html) => {
          const el = this.querySelector(`[data-ref="${ref}"]`);
          if (el) el.innerHTML = html;
        };
        const strong = (s) => `<strong>${escapeHtml(s)}</strong>`;

        const minLabel = fmtLong.format(r.deliveryMin);
        const range = r.deliveryMax > r.deliveryMin;
        const title = range ? t.titleRange || t.title : t.title;
        set('title', escapeHtml(title || 'Livrée le {date}')
          .replace('{date}', strong(minLabel))
          .replace('{date_max}', strong(fmtLong.format(r.deliveryMax))));

        let countdown;
        if (r.left <= 24 * 3600000) {
          const total = Math.max(1, Math.ceil(r.left / 60000));
          const h = Math.floor(total / 60);
          const m = total % 60;
          const value = h > 0 ? `${h} h ${String(m).padStart(2, '0')} min` : `${m} min`;
          countdown = escapeHtml(t.countdown || 'Commande dans les {countdown}').replace('{countdown}', strong(value));
        } else {
          const cutoffH = Math.floor(this.cfg.cutoff / 60);
          const cutoffM = this.cfg.cutoff % 60;
          const hour = `${cutoffH} h${cutoffM ? String(cutoffM).padStart(2, '0') : ''}`;
          const day = this.relative(r.orderDay, r.today) || fmtWeekday.format(r.orderDay);
          countdown = escapeHtml(t.deadline || 'Commande avant {deadline}').replace('{deadline}', strong(`${day} ${hour}`));
        }
        set('countdown-text', countdown);

        const short = (date) => {
          const rel = this.relative(date, r.today);
          return rel ? rel.charAt(0).toUpperCase() + rel.slice(1) : fmtShort.format(date);
        };
        set('date-order', escapeHtml(short(r.today)));
        set('date-ship', escapeHtml(short(r.shipDay)));
        set('date-delivery', escapeHtml(range ? `${fmtShort.format(r.deliveryMin)} – ${fmtShort.format(r.deliveryMax)}` : short(r.deliveryMin)));

        this.setAttribute('data-ready', '');
      }
    }

    customElements.define('aqee-delivery-eta', AqeeDeliveryEta);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aqee-panier-paliers"] && !Shopify.designMode) return;
  try {
    /**
   * Barre de paliers du panier latéral AqeeLab (voir le commentaire Liquid).
   * Rendu complet ici, synchrone à l'insertion du tiroir re-rendu.
   */
  (() => {
    if (customElements.get('aqee-panier-paliers')) return;

    const CHECK =
      '<svg class="aqee-pal__msg-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 10.5 3.2 3L15 6.5"/></svg>';

    const escapeHtml = (text) =>
      String(text ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

    /** Configuration des cadeaux par palier publiée par l'app (ou null). */
    function giftConfig() {
      const source = document.getElementById('aqee-cadeau-paliers-config');
      if (!source) return null;
      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return null;
      }
    }

    class AqeePanierPaliers extends HTMLElement {
      connectedCallback() {
        this.render();
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        if (!event.target.closest('[data-ref="choose-gift"]')) return;
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('aqee:cadeau-choix'));
      };

      money(cents, short = false) {
        let text;
        try {
          text = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          }).format(cents / 100);
        } catch (error) {
          text = `${(cents / 100).toFixed(2).replace('.', ',')} €`;
        }
        return short ? text.replace(/[.,]00(?=\D*$)/, '') : text;
      }

      steps() {
        const d = this.dataset;
        const t = this.texts;
        const total = Number(d.total) || 0;
        const giftBase = Number(d.giftBase) || 0;
        const paidIds = new Set((d.paidIds || '').split(',').filter(Boolean).map(Number));
        const giftIds = new Set((d.giftIds || '').split(',').filter(Boolean).map(Number));
        const hasPaid = paidIds.size > 0;
        const steps = [];

        [['relais', Number(d.relais)], ['domicile', Number(d.domicile)]].forEach(([key, threshold]) => {
          if (!(threshold > 0)) return;
          steps.push({
            key,
            threshold,
            amount: total,
            reached: total >= threshold,
            label: t[`${key}_label`],
            text: t[`${key}_text`],
          });
        });

        let config = giftConfig();
        if (!config && d.designMode !== undefined) {
          // Aperçu dans l'éditeur, app en pause ou absente.
          config = { seuilBarre: 5000, barre: [], seuilChoix: 15000, choix: [], secours: [] };
        }

        if (config) {
          const barre = config.barre?.[0];
          if (config.seuilBarre > 0) {
            steps.push({
              key: 'barre',
              threshold: config.seuilBarre,
              amount: giftBase,
              reached: (hasPaid && giftBase >= config.seuilBarre) || (barre && giftIds.has(barre.id)),
              label: t.barre_label,
              text: t.barre_text,
            });
          }

          if (config.seuilChoix > 0) {
            const products = [...(config.choix || []), ...(config.secours || [])];
            const chosen = products.find((p) => giftIds.has(p.id));
            const offered = (config.choix || []).filter((p) => p.disponible && !paidIds.has(p.id));
            const fallback = (config.secours || []).filter((p) => p.disponible && !paidIds.has(p.id));
            steps.push({
              key: 'choix',
              threshold: config.seuilChoix,
              amount: giftBase,
              reached: hasPaid && giftBase >= config.seuilChoix,
              label: t.choix_label,
              text: t.choix_text,
              chosen,
              canChoose: Boolean(chosen || offered.length || fallback.length),
            });
          }
        }

        return steps.sort((a, b) => a.threshold - b.threshold);
      }

      render() {
        try {
          this.texts = JSON.parse(this.dataset.texts || '{}');
        } catch (error) {
          this.texts = {};
        }

        const steps = this.steps();
        if (!steps.length) {
          this.hidden = true;
          return;
        }

        // Chaque jalon au centre d'une colonne de même largeur (place égale pour
        // son libellé) ; la piste se remplit d'un jalon au suivant, au prorata du
        // montant entre leurs deux seuils, et jusqu'au bout une fois tout atteint.
        const positions = steps.map((step, index) => ((2 * index + 1) * 50) / steps.length);
        let fill = 100;
        let previous = 0;
        for (const [index, step] of steps.entries()) {
          if (step.reached) {
            previous = step.threshold;
            continue;
          }
          const ratio = Math.max(0, Math.min(1, (step.amount - previous) / (step.threshold - previous)));
          const start = index === 0 ? 0 : positions[index - 1];
          fill = start + ratio * (positions[index] - start);
          break;
        }

        const next = steps.find((step) => !step.reached);
        const choice = steps.find((step) => step.key === 'choix' && step.reached && step.canChoose);
        let message;
        if (next) {
          message = escapeHtml(next.text).replace('[montant]', `<strong>${this.money(next.threshold - next.amount)}</strong>`);
        } else {
          message = escapeHtml(this.texts.all_done);
        }

        const stepsHtml = steps
          .map((step, index) => {
            const classes = ['aqee-pal__step'];
            if (index === steps.length - 1) classes.push('is-last');
            if (step.reached) classes.push('is-reached');
            // Jalon du cadeau au choix débloqué : son nom devient le lien qui ouvre
            // la fenêtre (« Choisir mon cadeau », puis « Modifier mon cadeau »).
            let name = this.texts[`${step.key}_short`];
            let nameClass = 'aqee-pal__name';
            if (step === choice) {
              name = choice.chosen ? this.texts.change_link : this.texts.choose_link;
              nameClass += ' aqee-pal__name--link';
            }
            const amount = `<span class="aqee-pal__amount"><b>${this.money(step.threshold, true)}</b>${
              name ? `<span class="${nameClass}">${escapeHtml(name)}</span>` : ''
            }</span>`;
            const title = `${step.label} dès ${this.money(step.threshold, true)}`;
            const inner = `<span class="aqee-pal__dot"></span>${amount}`;
            const style = `--pos: ${positions[index]}%`;
            if (step === choice) {
              return `<button type="button" class="${classes.join(' ')}" style="${style}" data-ref="choose-gift" title="${escapeHtml(title)}" aria-label="${escapeHtml(title)}">${inner}</button>`;
            }
            return `<span class="${classes.join(' ')}" style="${style}" title="${escapeHtml(title)}">${inner}</span>`;
          })
          .join('');

        this.hidden = false;
        this.querySelector('[data-ref="msg"]').innerHTML = (next ? '' : CHECK) + `<span>${message}</span>`;
        this.querySelector('[data-ref="rail"]').style.setProperty('--steps', String(steps.length));
        this.querySelector('[data-ref="rail"]').innerHTML =
          `<span class="aqee-pal__track"><span class="aqee-pal__fill" style="width: ${fill.toFixed(1)}%"></span></span>${stepsHtml}`;
      }
    }

    customElements.define('aqee-panier-paliers', AqeePanierPaliers);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aqee-shaker-offert"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('aqee-shaker-offert')) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    class AqeeShakerOffert extends HTMLElement {
      connectedCallback() {
        this.slotEl = this.querySelector('[data-aqee-shaker-slot]');
        this.template = this.querySelector('template[data-aqee-shaker-items]');
        this.inCart = this.dataset.inCart === 'true';

        this.onChoice = () => this.render();
        this.onCartUpdated = () => this.syncWithCart();
        this.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => input.addEventListener('change', this.onChoice));
        document.addEventListener('cart:updated', this.onCartUpdated);

        this.render();
        // Le HTML peut venir du cache : on relit le panier une fois.
        this.syncWithCart();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.onCartUpdated);
      }

      wantsShaker() {
        return this.querySelector('input[value="oui"]')?.checked === true;
      }

      // Champs items[99][...] présents dans le formulaire = shaker ajouté avec le produit.
      render() {
        const wants = this.wantsShaker();
        this.classList.toggle('is-yes', wants);
        this.classList.toggle('is-in-cart', this.inCart);

        if (wants && !this.inCart) {
          if (!this.slotEl.firstElementChild) this.slotEl.replaceChildren(this.template.content.cloneNode(true));
        } else {
          this.slotEl.replaceChildren();
        }
      }

      async syncWithCart() {
        try {
          const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          const cart = await response.json();
          this.inCart = cart.items.some((item) => item.properties && item.properties._aqee_gift === 'shaker');
        } catch (error) {
          // Panier illisible : on garde l'état connu.
        }
        this.render();
      }
    }

    customElements.define('aqee-shaker-offert', AqeeShakerOffert);
  })();
  } catch(e) { console.error(e); }
})();

})();
